import en from './en';

const ko = {
  ...en,
  languageSwitcher: {
    label: '언어',
    options: {
      en: 'EN',
      ja: 'JA',
      ko: 'KO',
      ms: 'MS',
      th: 'TH',
      tr: 'TR',
    },
    names: {
      en: '영어',
      ja: '일본어',
      ko: '한국어',
      ms: '말레이어',
      th: '태국어',
      tr: '터키어',
    },
  },
  nav: {
    home: '홈',
    privacy: '개인정보',
    terms: '이용약관',
    smsOptIn: 'SMS 인증',
    guidelines: '가이드라인',
    safety: '안전',
    deleteAccount: '계정 삭제',
    support: '지원',
    download: '다운로드',
    brandAriaLabel: '7Loves 홈',
    menuAriaLabel: '메뉴 열기',
  },
  store: {
    groupAriaLabel: '스토어 링크',
    appStoreAriaLabel: 'App Store에서 다운로드',
    appStoreOverline: 'App Store에서',
    appStoreTitle: '다운로드',
    googlePlayAriaLabel: 'Google Play에서 받기',
    googlePlayOverline: 'Google Play에서',
    googlePlayTitle: '다운로드',
  },
  home: {
    metaTitle: '홈',
    title: '7Loves에 오신 것을 환영합니다',
    subtitle: 'Blind Date - 먼저 매칭되고, 더 많은 정보는 천천히 공개됩니다.',
    intro:
      'Seven Loves는 진정성 있는 연결에 초점을 맞춘 현대적인 데이팅 앱입니다. 기존의 스와이프 중심 앱과 달리, Seven Loves는 먼저 연결되고 프로필이 점진적으로 공개되는 독특한 블라인드 매치 경험을 제공합니다.',
    howItWorks: '이용 방법',
    details:
      '사용자는 궁합을 기반으로 매칭되고, 대화를 시작하며, 시간이 지남에 따라 프로필 정보를 하나씩 확인하게 됩니다. 이 방식은 피상적인 스와이프보다 더 진정성 있는 연결을 유도합니다.',
    primaryCta: '다운로드',
    secondaryCta: '문의하기',
  },
  downloadPage: {
    metaTitle: '다운로드',
    title: '7Loves 받기',
    subtitlePrefix: '여기에서',
    subtitleSuffix: '계속 진행할 수 있습니다.',
    fallback: '원하면 아래 스토어 링크도 사용할 수 있습니다.',
    modalTitle: '스토어를 여시겠어요?',
    modalBodyPrefix: '이 기기에서',
    modalBodySuffix: '열어볼 수 있습니다.',
    primaryCta: '스토어 열기',
    secondaryCta: '지금은 안 함',
    backHome: '홈으로 돌아가기',
    destinations: {
      ios: 'App Store를',
      android: 'Google Play를',
    },
  },
  smsOptIn: {
    metaTitle: 'SMS 인증 동의',
    title: 'SMS 인증 동의',
    subtitle:
      '일회성 인증 코드를 받으려면 만 18세 이상임을 확인하고 휴대폰 번호를 입력해 주세요.',
    dobLabel: '생년월일 (DD/MM/YYYY)',
    dayPlaceholder: 'DD',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'YYYY',
    phoneLabel: '휴대폰 번호',
    phonePlaceholder: '+82 10 0000 0000',
    sendCode: '인증 코드 보내기',
    disclosure:
      '"인증 코드 보내기"를 누르면 본인이 만 18세 이상임을 확인하고, 인증 목적으로 Seven Loves가 발송하는 일회성 SMS 인증 코드를 수신하는 데 동의하게 됩니다. 문자 및 데이터 요금이 부과될 수 있습니다. 마케팅 메시지는 발송되지 않습니다.',
    privacyLink: '개인정보 처리방침',
  },
  pages: en.pages,
};

export default ko;
